import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import FloatingChatWidget from './components/FloatingChatWidget';
import reportWebVitals from './reportWebVitals';

// Check if we're in embedded mode
const isEmbedded = () => {
  // Check if n8nChatbotConfig exists (indicates embedding)
  if ((window as any).n8nChatbotConfig) {
    return true;
  }
  
  // Check if n8n-chat-container exists (indicates embedding)
  if (document.getElementById('n8n-chat-container')) {
    return true;
  }
  
  // Check URL parameters
  if (window.location.search.includes('embedded=true')) {
    return true;
  }
  
  return false;
};

// Check embedding mode
const shouldEmbed = isEmbedded();

if (shouldEmbed) {
  // EMBEDDED MODE: Render only the FloatingChatWidget
  let container = document.getElementById('n8n-chat-container');
  
  if (!container) {
    container = document.createElement('div');
    container.id = 'n8n-chat-container';
    document.body.appendChild(container);
  }
  
  const root = ReactDOM.createRoot(container);
  const config = (window as any).n8nChatbotConfig || {};
  
  root.render(
    <FloatingChatWidget
      webhookUrl={config.webhookUrl || "https://n8n.smartnoticeboard.io/webhook/b45daf0e-cfd7-4f5c-9f51-03414f6a1128/chat"}
      position={config.position || "bottom-right"}
      theme={{
        primary: '#1976d2',
        secondary: '#dc004e',
        background: '#ffffff',
        text: '#333333',
        userMessageBg: '#e3f2fd',
        userMessageText: '#000000',
        botMessageBg: '#f5f5f5',
        botMessageText: '#000000',
        headerBg: '#1976d2',
        headerText: '#ffffff',
        inputBg: '#ffffff',
        inputText: '#000000',
        borderRadius: '8px',
        fontFamily: 'Arial, sans-serif',
        ...config.theme
      }}
      layout={{
        showHeader: true,
        showMinimize: true,
        showClose: true,
        showAttachButton: true,
        headerTitle: config.layout?.headerTitle || 'Alpha Wolf Labs',
        headerSubtitle: config.layout?.headerSubtitle || 'Powered by AKITS',
        avatarSize: 32,
        messageMaxWidth: '70%',
        messageSpacing: 6,
        inputHeight: 48,
        ...config.layout
      }}
      behavior={{
        autoScroll: true,
        showTimestamps: true,
        showAgentName: true,
        showTypingIndicator: true,
        allowFileUpload: true,
        maxFileSize: 5,
        allowedFileTypes: ['image/*', 'application/pdf'],
        ...config.behavior
      }}
    />
  );
} else {
  // DEVELOPMENT MODE: Render the full App with demo content
  const rootElement = document.getElementById('root');
  if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(<App />);
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
